import {
  PersonAddressFormSchema,
  PersonAddressValidator,
} from "src/schemas/Address";
import {
  BASE_INITIAL_PARENT_FORM,
  ParentSchema,
  ParentValidator,
} from "src/schemas/Parent";
import { emptyStringAsNull, nullableWithDefault } from "src/services/zodExtra";
import { z } from "zod";

export const ParentProfileSchema = ParentSchema.extend({
  reference_id: nullableWithDefault(z.string(), ""),
}).merge(PersonAddressFormSchema);

export const ParentProfileValidator = ParentValidator.extend({
  reference_id: emptyStringAsNull(z.string()),
}).merge(PersonAddressValidator);

export const EmailRequiredParentProfileValidator =
  ParentProfileValidator.extend({
    email_address: z.string().min(1, "Required"),
    phone_number: z.string(),
  });

export const PhoneRequiredParentProfileValidator =
  ParentProfileValidator.extend({
    phone_number: z.string().min(12, "Required"),
    email_address: z.string(),
  });

// Creating a parent/guardian requires at least one contact method so the duplicate
// check is meaningful. The issue has no path, so it marks the form invalid (via the
// root error key) without attaching to a single input.
export const ContactRequiredParentProfileValidator =
  ParentProfileValidator.extend({
    email_address: z.string(),
    phone_number: z.string(),
  }).superRefine((values, ctx) => {
    if (!values.email_address.trim() && !values.phone_number.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "An email or a phone number is required",
      });
    }
  });

export type ParentProfileFormType = z.infer<typeof ParentProfileSchema>;

export const INITIAL_PARENT_FORM: ParentProfileFormType = {
  ...BASE_INITIAL_PARENT_FORM,
  reference_id: "",
  street_address: "",
  street_address_line_2: "",
  city: "",
  state: "",
  zip_code: "",
};
